<div class="definitions-container">
  <div class="definitions-header-wrapper">
    <mat-form-field class="definition-picker" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Välj tabell</mat-label>
      <mat-select [value]="selectedType()" (selectionChange)="selectDefinitionType($event)">
        @for (type of definitionTypes; track $index) {
        <mat-option [value]="type">
          {{ getDisplayName(type) }}
        </mat-option>
        }

      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="definitions-header-search search-filter">
      <mat-label>Sök</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Skriv för att filtrera" class="search-input">
    </mat-form-field>

  </div>

  @if (loading()) {
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>

  }
  @if (!loading()) {
  <mat-card class="definitions-table-card">
    <mat-card-content class="definitions-table-wrapper">
      <table mat-table [dataSource]="definitionDataSource" matSort class="mat-elevation-z2 definitions-table">
        <ng-container matColumnDef="shortName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Förkortning </th>
          <td mat-cell *matCellDef="let element">
            {{element.shortName}}
          </td>
          <td mat-footer-cell *matFooterCellDef class="short-name-form-td">
            <mat-form-field appearance="outline" class="short-name-form-field" subscriptSizing="dynamic">
              <input matInput appearance="outline" [(ngModel)]="newItem.shortName" placeholder="Förkortning"
                maxlength="8">
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Namn </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field appearance="outline" class="name-form-field" subscriptSizing="dynamic">
              <input matInput type="string" [(ngModel)]="element.name" (ngModelChange)="onInputChange(i)"
                [readonly]="!isPolicyPTAdmin">
            </mat-form-field>
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field appearance="outline" class="name-form-field" subscriptSizing="dynamic">
              <input matInput [(ngModel)]="newItem.name" placeholder="Skriv in namn" maxlength="35">
            </mat-form-field>
          </td>
        </ng-container>

        @if (isPolicyPTAdmin) {
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Lägg till/ta bort </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <div class="edit-action-buttons-wrapper">
              <button mat-raised-button (click)="saveRow(element, i)" [disabled]="!isRowModified(i)">Spara</button>
              <button mat-raised-button [disabled]="isDefinitionValueUsed(element)" (click)="deleteRow(element)">{{
                isDefinitionValueUsed(element) ? 'Värdet används'
                : 'Ta bort' }}
              </button>
              @if(selectedType() === manufacturerTypeValue) {
              <button mat-raised-button (click)="showManufacturerModels(element)"
                class="show-models-definition-button">Visa modeller</button>
              }
            </div>

          </td>
          <td mat-footer-cell *matFooterCellDef>
            <button mat-raised-button color="primary" (click)="addItem()" [disabled]="!isValidNewItem()">Lägg
              till</button>
          </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        @if (isPolicyPTAdmin) {
        <tr mat-footer-row *matFooterRowDef="displayedColumns" class="table-footer-row"></tr>
        }

      </table>
      <mat-paginator #definitionPaginator [pageSizeOptions]="[10, 20, 40, definitionDataSource.data.length]"
        showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
  }
</div>